(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-promo-field"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-cart-promo-field')) {
  customElements.define('pp-cart-promo-field', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.pp-cart-hybrid');
      this.input = this.querySelector('input');
      this.applyButton = this.querySelector('[data-pp-promo-apply]');
      this.status = this.querySelector('[role="status"]');
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.applyButton.addEventListener('click', () => this.apply(), options);
      this.input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        event.stopPropagation();
        this.apply();
      }, options);
      this.root.addEventListener('click', (event) => {
        const remove = event.target.closest('cart-discount-remove-button');
        if (!remove) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.apply(remove.getAttribute('discount-code'));
      }, { ...options, capture: true });
      this.root.addEventListener('submit', (event) => {
        if (!this.busy) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { ...options, capture: true });
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    codes(cart, applicableOnly = false) {
      const codes = new Map();
      for (const entry of cart.discount_codes || []) {
        if (entry.code && (!applicableOnly || entry.applicable === true)) codes.set(entry.code.toUpperCase(), entry.code);
      }
      const applications = [...(cart.cart_level_discount_applications || [])];
      for (const item of cart.items || []) {
        for (const allocation of item.line_level_discount_allocations || []) applications.push(allocation.discount_application);
      }
      for (const entry of applications) {
        if (entry?.type === 'discount_code' && entry.title) codes.set(entry.title.toUpperCase(), entry.title);
      }
      return [...codes.values()];
    }

    message(text, error = false) {
      this.status.textContent = text;
      this.status.toggleAttribute('data-error', error);
      this.input.setAttribute('aria-invalid', String(error));
    }

    setBusy(busy) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
      this.root.toggleAttribute('data-pp-discount-busy', busy);
      if (busy) {
        this.controls = [...this.root.querySelectorAll('button,input,textarea')].map(element => [element, element.disabled]);
        for (const [element] of this.controls) element.disabled = true;
      } else {
        for (const [element, disabled] of this.controls || []) element.disabled = disabled;
      }
    }

    async apply(removeCode = null) {
      if (this.busy) return;
      const code = removeCode === null ? this.input.value.trim() : removeCode;
      if (!code) {
        this.message(this.dataset.empty, true);
        this.input.focus();
        return;
      }
      this.message(this.dataset.loading);
      this.setBusy(true);
      const request = new AbortController();
      const timer = setTimeout(() => request.abort(), 25000);
      const cartUrl = this.dataset.cartUrl;
      const drawerSection = document.querySelector('cart-drawer')?.closest('.shopify-section');
      const drawerSectionId = drawerSection?.id.replace(/^shopify-section-/, '');
      const sections = [...new Set([this.dataset.sectionId, drawerSectionId].filter(Boolean))];
      try {
        const currentResponse = await fetch(`${cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store', signal: request.signal });
        if (!currentResponse.ok) throw new Error('cart-read');
        const current = await currentResponse.json();
        const existing = this.codes(current);
        const same = entry => entry.toUpperCase() === code.toUpperCase();
        if (removeCode === null && this.codes(current, true).some(same)) {
          this.message(this.dataset.already);
          return;
        }
        const codes = existing.filter(entry => !same(entry));
        if (removeCode === null) codes.push(code);
        const response = await fetch(`${cartUrl}/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          signal: request.signal,
          body: JSON.stringify({ discount: codes.join(','), sections, sections_url: cartUrl })
        });
        if (!response.ok) throw new Error('cart-update');
        const updated = await response.json();
        const accepted = this.codes(updated, true).some(same);
        const success = removeCode !== null ? !this.codes(updated).some(same) : accepted;
        const message = success ? (removeCode !== null ? this.dataset.removed : this.dataset.success) : this.dataset.invalid;
        const html = updated.sections?.[this.dataset.sectionId];
        const nextRoot = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.pp-cart-hybrid') : null;
        const drawerHtml = drawerSectionId ? updated.sections?.[drawerSectionId] : null;
        const nextDrawer = drawerHtml ? new DOMParser().parseFromString(drawerHtml, 'text/html').getElementById(drawerSection.id) : null;
        if (!nextRoot || !nextRoot.querySelector('pp-cart-promo-field') || (drawerSection && !nextDrawer)) {
          window.location.reload();
          return;
        }
        this.setBusy(false);
        if (drawerSection && nextDrawer) drawerSection.replaceWith(nextDrawer);
        this.root.replaceWith(nextRoot);
        const next = nextRoot.querySelector('pp-cart-promo-field');
        next.closest('details').open = true;
        next.message(message, !success);
        if (!success && removeCode === null) next.input.value = code;
        next.applyButton.focus({ preventScroll: true });
      } catch (error) {
        if (this.isConnected) this.message(this.dataset.error, true);
      } finally {
        clearTimeout(timer);
        if (this.isConnected) this.setBusy(false);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-mobile-customer"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mobile=matchMedia('(max-width:699px)');
 const root=document.querySelector('.shopify-section--main-product .product');
 const words=document.getElementById('pp-mobile-customer-text')?.dataset;
 if(!root||!words)return;
 let active=0,steps=[],gallery,price,buy,observer,raf=0,refreshFrame=0,enabled=false,purchaseSlot,priceHome,buyHome;
 const setText=(el,text)=>{if(el.textContent!==text)el.textContent=text};
 const topInset=()=>Math.max(0,...[...document.querySelectorAll('.shopify-section--announcement-bar,.shopify-section--header')].filter(e=>['sticky','fixed'].includes(getComputedStyle(e).position)).map(e=>Math.max(0,e.getBoundingClientRect().bottom)));
 function openStep(i){active=i;refresh();requestAnimationFrame(()=>{const target=steps[i]?.querySelector('.pp-mobile-step-toggle');if(!target)return;const offset=topInset()+gallery.offsetHeight+12;window.scrollBy({top:target.getBoundingClientRect().top-offset,behavior:'instant'});target.focus({preventScroll:true})})}
 function summary(step){
  const selected=step.querySelector('input[type="radio"]:checked');
  if(selected)return [...step.querySelectorAll('label')].find(e=>e.htmlFor===selected.id)?.textContent.trim()||'';
  return root.querySelector('[data-pp-customer]')?.dataset.summary||words.upload;
 }
 function refresh(){
  if(!enabled)return;
  const candidates=[...root.querySelectorAll('variant-picker>fieldset')];
  const upload=root.querySelector('[data-pp-customer]')?.closest('.product-info__block-item');
  if(upload){upload.classList.add('pp-mobile-upload');candidates.push(upload)}
  steps=candidates;
  steps.forEach((step,i)=>{
   if(!step.classList.contains('pp-mobile-step')){
    const legend=step===upload?words.upload:step.querySelector('legend')?.textContent.trim().replace(/:$/,'')||words.upload;
    const body=document.createElement('div');body.className='pp-mobile-step-body';body.id='pp-mobile-body-'+i;
    while(step.firstChild)body.append(step.firstChild);
    const toggle=document.createElement('button');toggle.type='button';toggle.className='pp-mobile-step-toggle';toggle.setAttribute('aria-controls',body.id);
    const title=document.createElement('strong');title.textContent=(i+1)+'. '+legend;
    const value=document.createElement('span');const icon=document.createElement('b');icon.setAttribute('aria-hidden','true');
    toggle.append(title,value,icon);toggle.addEventListener('click',()=>{if(active===i){active=-1;refresh()}else openStep(i)});
    step.append(toggle,body);step.classList.add('pp-mobile-step');
   }
   const body=step.querySelector(':scope>.pp-mobile-step-body');
   let next=body.querySelector(':scope>.pp-mobile-next');
   if(i<steps.length-1&&!next){
    next=document.createElement('button');next.type='button';next.className='pp-mobile-next';next.textContent=words.continue;
    next.addEventListener('click',()=>openStep(steps.indexOf(step)+1));body.append(next);
   }else if(i===steps.length-1&&next)next.remove();
   const open=i===active;step.dataset.open=String(open);
   const toggle=step.querySelector(':scope>.pp-mobile-step-toggle');toggle.setAttribute('aria-expanded',String(open));
   setText(toggle.querySelector('span'),summary(step));setText(toggle.querySelector('b'),open?'−':'+');
   const help=step.querySelector('.pp-edge-help-trigger');
   const orientation=step.querySelector('.pp-orientation-note__trigger');
   if(orientation&&!step.querySelector(':scope>.pp-mobile-orientation-help')){
    const original=document.getElementById(orientation.getAttribute('popovertarget'));
    if(original){
     const popup=original.cloneNode(true);popup.id=original.id+'-mobile';popup.classList.add('pp-mobile-orientation-popup');
     const title=popup.querySelector('.pp-orientation-note__title');title.id=popup.id+'-title';popup.setAttribute('aria-labelledby',title.id);
     popup.querySelector('[popovertargetaction="hide"]').setAttribute('popovertarget',popup.id);
     const control=document.createElement('button');control.type='button';control.className='pp-mobile-edge-help pp-mobile-orientation-help';control.setAttribute('popovertarget',popup.id);control.setAttribute('aria-haspopup','dialog');
     const icon=orientation.querySelector('.pp-orientation-note__icon')?.cloneNode(true);if(icon)control.append(icon);
     const label=document.createElement('span');label.textContent=[...orientation.childNodes].filter(n=>n.nodeType===3).map(n=>n.textContent).join('').trim();control.append(label);
     toggle.after(control,popup);
    }
   }
   if(help&&!step.querySelector(':scope>.pp-mobile-edge-help')){
    const control=document.createElement('button');control.type='button';control.className='pp-mobile-edge-help';
    const icon=help.querySelector('svg')?.cloneNode(true);if(icon){icon.removeAttribute('id');icon.setAttribute('aria-hidden','true');control.append(icon)}
    const label=document.createElement('span');label.textContent=words.edgeHelp;control.append(label);
    control.addEventListener('click',()=>step.querySelector('.pp-edge-help-trigger')?.click());step.append(control);
   }
  });
  const badge=root.querySelector('.jdgm-preview-badge')?.closest('.product-info__block-item');badge?.classList.add('pp-mobile-rating');
  updateSticky();
 }
 function updateSticky(){
  if(!enabled||raf)return;
  raf=requestAnimationFrame(()=>{raf=0;
   const base=topInset();
   const end=purchaseSlot.getBoundingClientRect().bottom;
   const top=Math.min(base,end-gallery.offsetHeight-12);
   const val=Math.round(top)+'px';if(gallery.style.getPropertyValue('--pp-mobile-top')!==val)gallery.style.setProperty('--pp-mobile-top',val);
  });
 }
 function queueRefresh(){
  if(!enabled||refreshFrame)return;
  refreshFrame=requestAnimationFrame(()=>{refreshFrame=0;observer?.disconnect();refresh();observer?.observe(root,{childList:true,subtree:true})});
 }
 function start(){
  if(enabled||!mobile.matches)return;
  gallery=root.querySelector('product-gallery');price=root.querySelector('[data-block-type="price"]');buy=root.querySelector('[data-block-type="buy-buttons"]');
  if(!gallery||!price||!buy)return false;
  if(!root.hasAttribute('data-pp-layout-trial')&&!gallery.querySelector('.starboard-super-container'))return false;
  enabled=true;
  priceHome=document.createComment('mobile price position');buyHome=document.createComment('mobile buy position');
  price.before(priceHome);buy.before(buyHome);
  purchaseSlot=document.createElement('div');purchaseSlot.className='pp-mobile-purchase-slot';
  const purchase=document.createElement('div');purchase.className='pp-mobile-purchase';
  buy.after(purchaseSlot);purchaseSlot.append(purchase);purchase.append(price,buy);
  root.classList.add('pp-mobile-config');refresh();
  observer=new MutationObserver(records=>{
   if(records.some(record=>record.target instanceof Element&&(record.target.closest('variant-picker,.pp-mobile-upload,[data-block-type="price"]')||[...record.addedNodes].some(node=>node instanceof Element&&(node.matches('variant-picker,[data-pp-customer]')||node.querySelector('variant-picker,[data-pp-customer]'))))))queueRefresh();
  });observer.observe(root,{childList:true,subtree:true});
  root.addEventListener('change',queueRefresh);
  document.addEventListener('pp:customer-change',queueRefresh);
  window.addEventListener('scroll',updateSticky,{passive:true});window.addEventListener('resize',updateSticky);
  return true;
 }
 function stop(){
  observer?.disconnect();enabled=false;cancelAnimationFrame(raf);cancelAnimationFrame(refreshFrame);raf=0;refreshFrame=0;root.removeEventListener('change',queueRefresh);document.removeEventListener('pp:customer-change',queueRefresh);root.classList.remove('pp-mobile-config');gallery?.style.removeProperty('--pp-mobile-top');
  const currentPrice=purchaseSlot?.querySelector('[data-block-type="price"]');
  const currentBuy=purchaseSlot?.querySelector('[data-block-type="buy-buttons"]');
  if(priceHome?.isConnected&&currentPrice)priceHome.replaceWith(currentPrice);if(buyHome?.isConnected&&currentBuy)buyHome.replaceWith(currentBuy);purchaseSlot?.remove();
  for(const popup of root.querySelectorAll('.pp-mobile-orientation-popup'))popup.remove();
  for(const title of root.querySelectorAll('[data-pp-original-text]')){title.textContent=title.dataset.ppOriginalText;delete title.dataset.ppOriginalText}
  for(const step of root.querySelectorAll('.pp-mobile-step')){const body=step.querySelector(':scope>.pp-mobile-step-body');body?.querySelector(':scope>.pp-mobile-next')?.remove();step.querySelector(':scope>.pp-mobile-edge-help')?.remove();step.querySelector(':scope>.pp-mobile-step-toggle')?.remove();if(body){body.replaceWith(...body.childNodes)}step.classList.remove('pp-mobile-step');delete step.dataset.open}
  window.removeEventListener('scroll',updateSticky);window.removeEventListener('resize',updateSticky);
 }
 let timer;
 function boot(){
  clearInterval(timer);
  if(!mobile.matches||start())return;
  let tries=0;
  timer=setInterval(()=>{if(start()||++tries>=60)clearInterval(timer)},500);
 }
 mobile.addEventListener('change',()=>{if(mobile.matches)boot();else{clearInterval(timer);stop()}});
 window.addEventListener('pagehide',()=>{clearInterval(timer);stop()});
 window.addEventListener('pageshow',event=>{if(event.persisted)boot()});
 boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-product-card-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-card-size-range')) {
    customElements.define('pp-card-size-range', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const choices = this.querySelector('.pp-b2__shape-switch');
        if (!choices) return;
        const buttons = [...choices.querySelectorAll('[data-pp-shape]')];
        const ranges = [...this.querySelectorAll('[data-pp-range]')];
        const select = shape => {
          ranges.forEach(range => { range.hidden = range.dataset.ppRange !== shape; });
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ppShape === shape)));
        };
        select(buttons[0].dataset.ppShape);
        choices.hidden = false;
        this.dataset.ready = 'true';
        choices.addEventListener('click', event => {
          const button = event.target.closest('[data-pp-shape]');
          if (button && choices.contains(button)) select(button.dataset.ppShape);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
